<template>
  <!-- Original Application text fields (with photo) and difference -->
  <td>
    <input v-if="field['type'] === 'text'" type="text" class="form-control"
           v-model="overrideFields[fieldKey]" @input="e => onFieldInput(fieldKey, e.target.value)"
           :id="fieldKey">
    <select v-else-if="field['type'] === 'select'" class="form-control"
            v-model="overrideFields[fieldKey]" @input="e => onFieldInput(fieldKey, e.target.value)">
      <option v-for="(optionName, optionKey) in field['options']" :value="optionKey">{{ optionName }}</option>
    </select>
    <img v-if="field['type'] === 'image'" :src="fieldValue(fieldKey, overrideFields, selectedFields)" class="img-thumbnail img-lg">
    <small class="form-text text-danger">{{ errors[fieldKey] }}</small>
    <div class="result-value" v-if="isOverridden(fieldKey) && field['type'] !== 'image'">
      <del class="clickable" data-toggle="tooltip" data-placement="top" title="Reset to original value"
           @click="resetToOriginalValue(fieldKey)">{{ application[fieldKey] }}
      </del>
      <span v-if="application[fieldKey]">-</span>
      <ins>{{ fieldValue(fieldKey, overrideFields, selectedFields) }}</ins>
    </div>
    <div v-else-if="isOverridden(fieldKey) && field['type'] === 'image'">
      <button class="btn btn-default btn-sm m-t-sm" data-toggle="tooltip" data-placement="top"
              title="Reset to original value"
              @click="resetToOriginalValue(fieldKey)">Reset
      </button>
    </div>
  </td>
</template>

<script>

import ApplicationsMerge from "../../mixins/ApplicationsMerge";

export default {
  mixins: [ApplicationsMerge],

  props: {
    application: {
      type: Object,
      required: true
    },
    fieldKey: {
      type: String,
      required: true
    },
    field: {
      type: Object,
      required: true
    },
    overrideFields: {
      type: Object,
      required: true
    },
    selectedFields: {
      type: Object,
      required: true
    },
    duplicates: {
      type: Object,
      required: true
    },
    duplicateIds: {
      type: Array,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    phoneMask: {
      type: Object,
      default: null
    },
  },

  mounted() {
    const phoneFields = ['cell_phone', 'home_phone'];

    if (phoneFields.includes(this.fieldKey)) {
      let mask = new Inputmask(this.phoneMask?.mask);
      let phoneSelector = document.getElementById(this.fieldKey);

      mask.mask(phoneSelector);
    }
  },

  methods: {

    // Event handler for user input overriding field value.
    onFieldInput(fieldKey, val) {
      this.uncheckFieldSelections(fieldKey);
    },

    // Determine if field value was overridden manually or by duplicate selection.
    isOverridden(fieldKey) {

      let overridden = false;

      this.duplicateIds.forEach((id) => {
        if (this.selectedFields[fieldKey].includes(id) &&
          this.normalizeValue(this.application[fieldKey]) !== this.normalizeValue(this.duplicates[id][fieldKey])) {
          overridden = true;
          return false;
        }
      });

      return overridden || (this.normalizeValue(this.application[fieldKey]) !== this.normalizeValue(this.overrideFields[fieldKey]));
    },

    // Reset overridden Application field to its original value.
    resetToOriginalValue(fieldKey) {
      this.selectedFields[fieldKey].splice(0, this.selectedFields[fieldKey].length);
      this.overrideFields[fieldKey] = this.application[fieldKey];
    },

    // Uncheck all field's checkboxes.
    uncheckFieldSelections(fieldKey) {

      this.duplicateIds.forEach((dupId) => {
        let index = this.selectedFields[fieldKey].indexOf(dupId);
        if (index >= 0) {
          this.selectedFields[fieldKey].splice(index, 1);
        }
      });
    },

  },
}
</script>

<style scoped>

.result-value {
  margin: 5px 0 0 8px;
}

del, ins {
  padding: 2px 5px;
  border-radius: 5px;
}

.clickable {
  cursor: pointer;
}

</style>
